// extracted by css-extract-rspack-plugin
export default {"gridContainer":"_4d51bc6","isQuickFiltersRedesignVariant":"_5360ae67"};